import { styled } from '../../../config'

export const FormFieldLabel = styled('label', {
  fontSize: '12px',
  lineHeight: '20px',
  paddingBottom: '6px',
  fontWeight: 500,
  color: '$gray1000',
  variants: {
    secondary: {
      true: {
        color: '$gray0200'
      }
    }
  }
})
